


export type BillHistoryType = 'Creation' | 'Updated' | 'WorkspaceAssignment' | 'CostAssigment' | 'CostVisa' | 'Approved' | 'TransmissionSucceeded' | 'TransmissionFailed' | 'TransmissionRequested' | 'ProjectBookingSucceeded' | 'ProjectBookingFailed' | 'ProjectDossierSucceeded' | 'ProjectDossierFailed' | 'AccountingCompleted' | 'AccountingReset' | 'ApprovalRequested' | 'VisaRepeatRequired' | 'VisaRepeated' | 'VisaOverridden' | 'DocumentAdded' | 'DocumentRemoved' | 'DeadlineStarted';

export const BillHistoryType = {
    Creation: 'Creation' as BillHistoryType,
    Updated: 'Updated' as BillHistoryType,
    WorkspaceAssignment: 'WorkspaceAssignment' as BillHistoryType,
    CostAssigment: 'CostAssigment' as BillHistoryType,
    CostVisa: 'CostVisa' as BillHistoryType,
    Approved: 'Approved' as BillHistoryType,
    TransmissionSucceeded: 'TransmissionSucceeded' as BillHistoryType,
    TransmissionFailed: 'TransmissionFailed' as BillHistoryType,
    TransmissionRequested: 'TransmissionRequested' as BillHistoryType,
    ProjectBookingSucceeded: 'ProjectBookingSucceeded' as BillHistoryType,
    ProjectBookingFailed: 'ProjectBookingFailed' as BillHistoryType,
    ProjectDossierSucceeded: 'ProjectDossierSucceeded' as BillHistoryType,
    ProjectDossierFailed: 'ProjectDossierFailed' as BillHistoryType,
    AccountingCompleted: 'AccountingCompleted' as BillHistoryType,
    AccountingReset: 'AccountingReset' as BillHistoryType,
    ApprovalRequested: 'ApprovalRequested' as BillHistoryType,
    VisaRepeatRequired: 'VisaRepeatRequired' as BillHistoryType,
    VisaRepeated: 'VisaRepeated' as BillHistoryType,
    VisaOverridden: 'VisaOverridden' as BillHistoryType,
    DocumentAdded: 'DocumentAdded' as BillHistoryType,
    DocumentRemoved: 'DocumentRemoved' as BillHistoryType,
    DeadlineStarted: 'DeadlineStarted' as BillHistoryType
};

